export default __webpack_public_path__ + "static/media/explore4.b862b27c.png";